import type { UUID } from '@protector/utils/types';
import type { FileModel, UploadFileItem } from './upload-file.models';

export const UploadFileActionsTypes = {
  LOAD_UPLOAD_FILE_LIST: '[Analytics/UploadFile] Load List',
  LOAD_UPLOAD_FILE_LIST_SUCCESS: '[Analytics/UploadFile] Load List Success',
  LOAD_UPLOAD_FILE_LIST_FAILURE: '[Analytics/UploadFile] Load List Failure',

  LOAD_UPLOAD_FILE_IMAGES: '[Analytics/UploadFile] Load Images',
  LOAD_UPLOAD_FILE_IMAGES_SUCCESS: '[Analytics/UploadFile] Load Images Success',
  LOAD_UPLOAD_FILE_IMAGES_FAILURE: '[Analytics/UploadFile] Load Images Failure',

  DELETE_UPLOAD_FILE: '[Analytics/UploadFile] Delete Upload File',
  DELETE_UPLOAD_FILE_SUCCESS: '[Analytics/UploadFile] Delete Upload File Success',
  DELETE_UPLOAD_FILE_FAILURE: '[Analytics/UploadFile] Delete Upload File Failure',

  UPDATE_UPLOAD_FILE: '[Analytics/UploadFile] Update Upload File',
  UPDATE_UPLOAD_FILE_SUCCESS: '[Analytics/UploadFile] Update Upload File Success',
  UPDATE_UPLOAD_FILE_FAILURE: '[Analytics/UploadFile] Update Upload File Failure',

  POST_UPLOAD_FILE: '[Analytics/UploadFile] Post Upload File',
  POST_UPLOAD_FILE_SUCCESS: '[Analytics/UploadFile] Post Upload File Success',
  POST_UPLOAD_FILE_FAILURE: '[Analytics/UploadFile] Post Upload File Failure'
} as const;

// LOAD UPLOAD FILE LIST
export const LoadUploadFileList = () => {
  return {
    type: UploadFileActionsTypes.LOAD_UPLOAD_FILE_LIST
  };
};

export const LoadUploadFileListSuccess = (list: UploadFileItem[]) => {
  return {
    type: UploadFileActionsTypes.LOAD_UPLOAD_FILE_LIST_SUCCESS,
    payload: list
  };
};

export const LoadUploadFileListFailure = (error: string) => {
  return {
    type: UploadFileActionsTypes.LOAD_UPLOAD_FILE_LIST_FAILURE,
    payload: error
  };
};

// DELETE UPLOAD FILE
export const DeleteUploadFile = (id: UUID) => {
  return {
    type: UploadFileActionsTypes.DELETE_UPLOAD_FILE,
    payload: id
  };
};

export const DeleteUploadFileSuccess = () => {
  return {
    type: UploadFileActionsTypes.DELETE_UPLOAD_FILE_SUCCESS
  };
};

export const DeleteUploadFileFailure = (error: string) => {
  return {
    type: UploadFileActionsTypes.DELETE_UPLOAD_FILE_FAILURE,
    payload: error
  };
};

// UPDATE UPLOAD FILE
export const UpdateUploadFile = (metadata: UploadFileItem) => {
  return {
    type: UploadFileActionsTypes.UPDATE_UPLOAD_FILE,
    payload: metadata
  };
};

export const UpdateUploadFileSuccess = () => {
  return {
    type: UploadFileActionsTypes.UPDATE_UPLOAD_FILE_SUCCESS
  };
};

export const UpdateUploadFileFailure = (error: string) => {
  return {
    type: UploadFileActionsTypes.UPDATE_UPLOAD_FILE_FAILURE,
    payload: error
  };
};

// POST UPLOAD FILE
export const PostUploadFile = (file: File, metadata: UploadFileItem) => {
  return {
    type: UploadFileActionsTypes.POST_UPLOAD_FILE,
    payload: { file, metadata }
  };
};

export const PostUploadFileSuccess = (metadata: UploadFileItem) => {
  return {
    type: UploadFileActionsTypes.POST_UPLOAD_FILE_SUCCESS,
    payload: metadata
  };
};

export const PostUploadFileFailure = (error: string) => {
  return {
    type: UploadFileActionsTypes.POST_UPLOAD_FILE_FAILURE,
    payload: error
  };
};

// LOAD UPLOAD FILE IMAGES
export const LoadUploadFileImages = (id: UUID) => {
  return {
    type: UploadFileActionsTypes.LOAD_UPLOAD_FILE_IMAGES,
    payload: id
  };
};

export const LoadUploadFileImagesSuccess = (item: FileModel, id: string) => {
  return {
    type: UploadFileActionsTypes.LOAD_UPLOAD_FILE_IMAGES_SUCCESS,
    payload: { item, id }
  };
};

export const LoadUploadFileImagesFailure = (error: string) => {
  return {
    type: UploadFileActionsTypes.LOAD_UPLOAD_FILE_IMAGES_FAILURE,
    payload: error
  };
};
